import { Component, Input } from "@angular/core";
import { LastFive } from "src/app/models/games/games.models";
import { StatsService } from "src/app/services/stats/stats-service";

@Component({
  selector: "app-last-games",
  standalone: false,
  // imports: [],
  templateUrl: "./last-games.component.html",
  styleUrl: "./last-games.component.scss",
})
export class LastGamesComponent {
  @Input() team: string;
  @Input() opponentTeam: string;
  @Input() date: string;
  @Input() location: string;
  lastGames: LastFive;
  lastGamesRoad: LastFive;
  lastGamesHome: LastFive;
  lastGamesOpponent: LastFive;

  constructor(private statsService: StatsService) {}

  async ngOnInit(): Promise<void> {
    if (this.location == "road") {
      this.statsService
        // .getLastFive(this.team, this.date)
        .getLastFiveHomeRoad(this.team, this.date, this.location)
        .subscribe(
          (lastFiveRoad) => {
            this.lastGames = lastFiveRoad;
          },
          (error) => {
            console.log("team => ", this.team);
            console.log("this.date => ", this.date);
            console.log("this.location => ", this.location);
            
            console.error("Error fetching last five games ROAD:", error);
          }
        );

         this.statsService
        // .getLastFive(this.team, this.date)
        .getLastFiveHomeRoad(this.opponentTeam, this.date, "home")
        .subscribe(
          (lastFiveOpponent) => {
            this.lastGamesOpponent = lastFiveOpponent;
          },
          (error) => {
            console.log("team => ", this.team);
            console.log("this.date => ", this.date);
            console.log("this.location => ", this.location);
            
            console.error("Error fetching last five games opponent Home:", error);
          }
        );
    } else if (this.location == "home") {
      this.statsService
        // .getLastFive(this.team, this.date)
        .getLastFiveHomeRoad(this.team, this.date, this.location)
        .subscribe(
          (lastFiveRoad) => {
            this.lastGames = lastFiveRoad;
          },
          (error) => {
            console.error("Error fetching last five games HOME:", error);
          }
        );

                 this.statsService
        // .getLastFive(this.team, this.date)
        .getLastFiveHomeRoad(this.opponentTeam, this.date, "road")
        .subscribe(
          (lastFiveOpponent) => {
            this.lastGamesOpponent = lastFiveOpponent;
          },
          (error) => {
            console.log("team => ", this.team);
            console.log("this.date => ", this.date);
            console.log("this.location => ", this.location);
            
            console.error("Error fetching last five games opponent Road:", error);
          }
        );
    } else {
      this.statsService.getLastFive(this.team, this.date).subscribe(
        (lastFiveListRoad) => {
          this.lastGames = lastFiveListRoad;
        },
        (error) => {
          console.error("Error fetching last five games Total:", error);
        }
      );

        this.statsService.getLastFive(this.opponentTeam, this.date).subscribe(
          (lastFiveOpponent) => {
            this.lastGamesOpponent = lastFiveOpponent;
          },
          (error) => {
            console.log("team => ", this.team);
            console.log("this.date => ", this.date);
            console.log("this.location => ", this.location);
            
            console.error("Error fetching last five games opponent all:", error);
          }
        );
    }
  }

alreadyPlayed(team: string): boolean {
  return (this.lastGamesOpponent as unknown as LastFive[] || []).some(current => current.opponent === team);
}
}
